// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonGroup } from 'speed-js-react-web';
import Button from 'esm-web-pro/components/layout/GreyButton';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import { sensitivePanelIsOpened as sensitivePanelIsOpenedSelector } from 'esm-web-pro/redux/side-panel';
import styled from 'styled-components';

const messages = defineMessages({
    'edit-new': {
        id: 'map-edit-new',
        defaultMessage: 'Edit',
    },
    edit: {
        id: 'map-edit',
        defaultMessage: 'Edit',
    },
    activate: {
        id: 'map-activate',
        defaultMessage: 'Activate Map',
    },
    discard: {
        id: 'map-discard',
        defaultMessage: 'Discard Map',
    },
});

type Props = {
    activeMap: Object,
    currentMap: Object,
    draftMap: Object,
    mapLoading: boolean,
    editedByOtherUsers: boolean,
    onActivate: Function,
    onDiscard: Function,
    onNewDraft: Function,
    onShowDraft: Function,
    sensitivePanelIsOpened: boolean,
    intl: IntlShape,
};

const MapEditorSelectorButtons = (props: Props) => {
    const {
        activeMap, draftMap, currentMap, mapLoading, editedByOtherUsers, onActivate, onDiscard,
        onNewDraft, onShowDraft, sensitivePanelIsOpened, intl: { formatMessage },
    } = props;

    const buttons = [];
    if (currentMap && activeMap && currentMap === activeMap) {
        const { has_draft: hasDraft } = activeMap;
        if (draftMap) {
            buttons.push(
                <Button
                    key={`${currentMap.uuid}-show-draft-btn`}
                    label={formatMessage(messages.edit)}
                    onClick={onShowDraft}
                    disabled={mapLoading || editedByOtherUsers}
                />,
            );
        } else if (!hasDraft) {
            buttons.push(
                <Button
                    key={`${currentMap.uuid}-new-draft-btn`}
                    label={formatMessage(messages['edit-new'])}
                    onClick={onNewDraft}
                    disabled={mapLoading || editedByOtherUsers}
                />,
            );
        }
    } else if (currentMap && draftMap && currentMap === draftMap) {
        buttons.push(
            <Button
                key={`${currentMap.uuid}-activate-draft-btn`}
                label={formatMessage(messages.activate)}
                onClick={onActivate}
                disabled={mapLoading || !!sensitivePanelIsOpened}
            />,
            <Button
                key={`${currentMap.uuid}-discard-draft-btn`}
                label={formatMessage(messages.discard)}
                onClick={onDiscard}
                disabled={mapLoading}
            />,
        );
    }

    return (
        <ButtonGroup direction="row">
            {buttons}
        </ButtonGroup>
    );
};

const mapStateToProps = (state) => ({
    sensitivePanelIsOpened: sensitivePanelIsOpenedSelector(state),
});

export default injectIntl(connect(mapStateToProps)(MapEditorSelectorButtons));
